import { useMemo } from 'react';

import type { AdditionalChainInstance } from '../additionalChainUtils';
import { buildAdditionalChainInstanceOverlay } from '../additionalChainUtils';
import AdditionalDiagramCardFrame from './AdditionalDiagramCardFrame';
import BoneAssignmentDiagram from './BoneAssignmentDiagram';

interface AdditionalChainDiagramCardProps {
  instance: AdditionalChainInstance;
  activeChainName: string | null;
  focusedChainName: string | null;
  hoveredChainName: string | null;
  pendingChainName: string | null;
  onHoveredChainChange: (chainName: string | null) => void;
  onChainClick: (chainName: string) => void;
  onChainClear?: (chainNames: readonly string[]) => void;
}

export default function AdditionalChainDiagramCard({
  instance,
  activeChainName,
  focusedChainName,
  hoveredChainName,
  pendingChainName,
  onHoveredChainChange,
  onChainClick,
  onChainClear,
}: AdditionalChainDiagramCardProps) {
  const { segments, nodeMarkers } = useMemo(
    () =>
      buildAdditionalChainInstanceOverlay(instance, {
        focusedChainName,
        pendingChainName,
      }),
    [focusedChainName, instance, pendingChainName],
  );

  return (
    <AdditionalDiagramCardFrame
      displayLabel={instance.displayLabel}
      removableChainNames={instance.removableChainNames}
      onChainClear={onChainClear}
    >
      <BoneAssignmentDiagram
        mode="chains"
        diagram={instance.diagram}
        chainSegments={segments}
        chainNodeMarkers={nodeMarkers}
        hoveredChainName={hoveredChainName}
        onHoveredChainChange={onHoveredChainChange}
        onChainClick={onChainClick}
      />
    </AdditionalDiagramCardFrame>
  );
}
